import type { BloodPressureThresholds } from "../preferences/types";

export type BloodPressureCategory = "nonElevated" | "elevated" | "hypertension";

export const escBloodPressureReference = {
  sourceUrl: "https://www.escardio.org/static-file/Escardio/Guidelines/Documents/ESC-Patient-Guidelines-Hypertension.pdf",
  year: 2024,
  systolicHypertension: 135,
  diastolicHypertension: 85,
} as const;

export function classifyBloodPressure(systolic: number, diastolic: number, customThresholds?: BloodPressureThresholds): BloodPressureCategory {
  if (systolic < 120 && diastolic < 70) return "nonElevated";
  const threshold = customThresholds
    ? { systolicHypertension: customThresholds.systolic, diastolicHypertension: customThresholds.diastolic }
    : escBloodPressureReference;
  if (systolic >= threshold.systolicHypertension || diastolic >= threshold.diastolicHypertension) return "hypertension";
  return "elevated";
}
